;(function () {
  'use strict'

  angular
    .module('contrast.log-enhancer')
    .factory(
      'logEnhancerApiConfig',
      function logEnhancerApiConfigFactory($http, UserService) {
        'ngInject'

        return {
          getLogEnhancers: getLogEnhancers,
          getQuickFilters: getQuickFilters,
          getLogEnhancer: getLogEnhancer,
          deleteLogEnhancer: deleteLogEnhancer,
          toggleEnabled: toggleEnabled,
          addLogEnhancer: addLogEnhancer,
          editLogEnhancer: editLogEnhancer
        }

        function getLogEnhancers(filters) {
          return $http.get(UserService.buildAPIUrl('/log'), { params: filters })
        }

        function getQuickFilters(filters) {
          return $http.get(UserService.buildAPIUrl('/log/filters/quick'), {
            params: filters
          })
        }

        function getLogEnhancer(logId) {
          return $http.get(UserService.buildAPIUrl('/log/' + logId))
        }

        function deleteLogEnhancer(logId) {
          return $http['delete'](UserService.buildAPIUrl('/log/' + logId))
        }

        function toggleEnabled(logId, environment) {
          return $http.post(
            UserService.buildAPIUrl('/log/' + logId + '/enable/' + environment)
          )
        }

        function addLogEnhancer(form) {
          return $http.put(UserService.buildAPIUrl('/log'), form)
        }

        function editLogEnhancer(id, form) {
          return $http.post(UserService.buildAPIUrl('/log/' + id), form)
        }
      }
    )
})()
